import React from 'react'

const LeftArrowIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.396 6.7925L13.1035 5.5L7.60352 11L13.1035 16.5L14.396 15.2075L10.1977 11L14.396 6.7925Z"
        fill="#282725"
      />
    </svg>
  )
}

export default LeftArrowIcon
